import {
  ShowProps,
  SimpleShowLayout,
  TextField,
  ReferenceField,
  DateField,
  BooleanField,
  RichTextField,
} from "react-admin";
import { DefaultShow, UploadedFilesField } from "../../../../lib/components";
import { COMMON_DATE_TIME_FORMAT } from "../../../../lib/core";
import { RESOURCE_NAME_ITEM_GROUPS } from "../itemsGroup";
import { RESOURCE_NAME_ITEM_SEGMENTS } from "./constants";

const ItemSegmentShow= (props:ShowProps) => {
  return (
    <DefaultShow {...props}>
      <SimpleShowLayout>
        <TextField source="number" />
        <TextField source="name" />
        <RichTextField source="description" />
        <ReferenceField
          source="parentId"
          reference={RESOURCE_NAME_ITEM_SEGMENTS}
        >
          <TextField source="displayLabel" />
        </ReferenceField>
        <ReferenceField
          source="itemGroupId"
          reference={RESOURCE_NAME_ITEM_GROUPS}
        >
          <TextField source="displayLabel" />
        </ReferenceField>
        <DateField source="createdAt" options={COMMON_DATE_TIME_FORMAT} />
        <DateField source="updatedAt" options={COMMON_DATE_TIME_FORMAT} />
        <TextField source="version" />
        <BooleanField source="isActive" />
        {/* <ArrayField label="Items" source={RESOURCE_NAME_ITEM}>
                    <Datagrid>
                        <TextField source="createdAt"/>
                        <TextField source="updatedAt"/>
                    </Datagrid>
                </ArrayField> */}
        <UploadedFilesField canDelete={false} />
      </SimpleShowLayout>
    </DefaultShow>
  );
};

export { ItemSegmentShow };
